module.exports = __webpack_public_path__ + "static/media/main idea.0a1ee284.mp3";